import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

/** Offerings whose group row starts expanded, seeded from `isExpanded` on fetch. */
export const selectMarketYoyGrowthExpectationExpandedOfferings = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.expandedOfferings
)
